// import createCache from '@emotion/cache';
// import { CacheProvider } from '@emotion/react';
// import { FunctionComponent, StrictMode } from 'react';
// import { HelmetProvider } from 'react-helmet-async';
// import { ContainerInstance } from 'typedi';
// import { App } from '../../App';
// import { ContainerProvider } from '../../hooks/useContainer';
// import { memberCenterTheme } from '../../theme';
// import { ErrorBoundaryProvider } from '../ErrorBoundaryProvider/ErrorBoundaryProvider';
// import { I18nReduxProvider } from '../I18nReduxProvider/I18nReduxProvider';
// import { ReduxProvider } from '../ReduxProvider/ReduxProvider';
import { type FunctionComponent, StrictMode } from 'react';
import { type ContainerInstance } from 'typedi';
import { App } from '../../App';
import { Toaster } from '../../atoms/Toaster/Toaster';
import { type PrayerStreamStore } from '../../core/store';
import { ContainerProvider } from '../../hooks/useContainer';
import { I18nProvider } from '../../i18n/resources';
import { ErrorBoundaryProvider } from '../ErrorBoundaryProvider/ErrorBoundaryProvider';
import { ReduxProvider } from '../ReduxProvider/ReduxProvider';

export type AppProvidersProps = {
  container: ContainerInstance;
  store: PrayerStreamStore;
};

export const AppProviders: FunctionComponent<AppProvidersProps> = ({
  container,
  store,
}) => {
  return (
    // <CacheProvider value={muiCache}>
    //   <ThemeProvider theme={memberCenterTheme}>
    //     <ContainerProvider container={container}>
    //       <ReduxProvider>
    //         <I18nReduxProvider>
    //           <ErrorBoundaryProvider boundaryName="AppProviders">
    //             <StrictMode>
    //               <StyledEngineProvider injectFirst>
    //                 <CssBaseline />
    //                 <HelmetProvider>
    //                   <App />
    //                 </HelmetProvider>
    //               </StyledEngineProvider>
    //             </StrictMode>
    //           </ErrorBoundaryProvider>
    //         </I18nReduxProvider>
    //       </ReduxProvider>
    //     </ContainerProvider>
    //   </ThemeProvider>
    // </CacheProvider>

    <ContainerProvider container={container}>
      <ReduxProvider store={store}>
        <I18nProvider locale="en-US">
          <ErrorBoundaryProvider boundaryName="AppProviders">
            <StrictMode>
              <Toaster />
              <App />
            </StrictMode>
          </ErrorBoundaryProvider>
        </I18nProvider>
      </ReduxProvider>
    </ContainerProvider>
  );
};
